import { css } from "@emotion/react";
import { Spacing } from "@snapchat/snap-design-system";

export const videoElement = css`
    height: 100%;
    width: 100%;
    max-width: 533px;
    max-height: 400px;
    border-radius: 8px;
    margin: ${Spacing.MD}px 0;
`;

export const lensSelectStyle = css`
    margin-right: ${Spacing["1XS"]}px;
`;

export const selectionStyle = css`
    margin: 0 ${Spacing["1XS"]}px 3px ${Spacing["1XS"]}px;
`;

export const sourceLoading = css`
    position: absolute;
    height: 352px;
    width: 470px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const containerStyle = css`
    max-width: 533px;
    max-height: 400px !important;
    margin-right: ${Spacing.SM}px;
`;
